import { useMemo } from 'react';

import { SearchResult, SearchResultType } from '../models';

type LonLatResult = SearchResult<[number, number]> | null;

export const useLonLatSearch = (location: string): LonLatResult => {
  // This function is used to handle lat long input. Always Long, Lat
  const handleLongLat = (val: string): [number, number] | null => {
    const latLong = val.split(',');
    if (latLong.length !== 2) return null;

    const long = parseFloat(latLong[1]);
    const lat = parseFloat(latLong[0]);

    if (!long || !lat || Number.isNaN(long) || Number.isNaN(lat)) {
      return null;
    }

    if (long < -180 || long > 180 || lat < -90 || lat > 90) {
      return null;
    }

    return [long, lat];
  };

  const lonLat: SearchResult<[number, number]> | null = useMemo(() => {
    const longLatLocation = handleLongLat(location);
    if (!longLatLocation) return null;
    const label = `${longLatLocation[1]}, ${longLatLocation[0]}`;

    return {
      geometry: {
        coordinates: [longLatLocation[0], longLatLocation[1]],
        type: 'Point',
      },
      id: label,
      label,
      onClick: () => {},
      original: [longLatLocation[0], longLatLocation[1]],
      type: SearchResultType.GO_TO_POINT,
    };
  }, [location]);

  return lonLat;
};
